// import components
import { InputAdornment } from '@mui/material';
import { StyledBoxFlexCenter } from 'components/shared/Box/Box.styles';
import { ControlledTextField } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import { KmSettingsProps } from './KmSettings.types';

const KmSettings = ({
  control,
  isEmployeePortal,
  disabled
}: KmSettingsProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'hoursTable.dutyInformation'
  });

  return (
    <MultiStepForm.Section
      key={'finEmpKmManual'}
      title={t('dutyKm')}
      validateFields={['finEmpKmManual', 'finEmpTravelExpensesManual']}
    >
      <StyledBoxFlexCenter>
        <ControlledTextField
          control={control}
          name="finEmpKmManual"
          label={t('finEmpKmManual')}
          disabled={isEmployeePortal || disabled}
          fullWidth
        />

        <ControlledTextField
          control={control}
          name="finEmpTravelExpensesManual"
          label={t('finEmpTravelExpensesManual')}
          disabled={isEmployeePortal || disabled}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">&euro;</InputAdornment>
              )
            }
          }}
          fullWidth
        />
      </StyledBoxFlexCenter>
    </MultiStepForm.Section>
  );
};

export default KmSettings;
